import { render, staticRenderFns } from "./BlockedCover.vue?vue&type=template&id=6c84b873&scoped=true&"
import script from "./BlockedCover.vue?vue&type=script&lang=js&"
export * from "./BlockedCover.vue?vue&type=script&lang=js&"
import style0 from "./BlockedCover.vue?vue&type=style&index=0&id=6c84b873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84b873",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
